<script>
import render from '@/render/render'
import Vue from 'vue'
import { copy } from '@/utils'
export default {
    name: 'Card',
    props: {
        rows: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: '卡片标题'
        },
        shadow: {
            type: String,
            default: 'always'
        }
    },
    data() {
        return {
            info: {},
            propRows: copy(this.rows),
            design: false,
        }
    },
    watch: {
        value: {
            handler(value) {
                if(Array.isArray(value)) {
                    // 转化数据为formData模式
                    value.map(item => {
                       this.info[item.key] = item.value
                    })
                }
            },
            immediate: true,
        },
        propRows: {
            handler(value) {
                const { eventHub, __vModel__ } = this.$attrs
                eventHub.emit('designProps', { property: 'rows', data: value, key: __vModel__} )
            },
            deep: true
        }
    },
    created() {
        const { componentToRegister, design } = this.$attrs
            if(design) {
                this.design = true
            }
            if(Array.isArray(componentToRegister)) {
                const [DraggableItem, draggable] = componentToRegister
                console.log(componentToRegister, componentToRegister.name)
                this.$options.components['draggable-item'] = DraggableItem
                this.$options.components['draggable'] = draggable
            }
    },
    methods: {
        delItem (index) {
            this.propRows.splice(index, 1)
        },
        activeItem(item) {
            const { eventHub } = this.$attrs
            eventHub.emit('activeItem', item )
        }
    },
    render(h) {
        const { propRows, rows, title, shadow, info, activeItem, delItem } = this
        const { formSlot: { scopedSlots } } = this.$attrs
        const setValue = (value, key) => {
            console.log(value, key)
            const keys = Object.keys(this.info)
            const data = keys.map(key => {
                return {
                    key,
                    value: this.info[key]
                }
            })
            const hasItem = data.find(item => item.key === key)
            if(hasItem) {
                hasItem.value = value
            } else {
                data.push({key, value})
            }


            this.$emit('input', data)
        }
        const { design } = this.$attrs
        return (
            <el-card class="box-card" shadow={shadow}>
                <div slot="header">
                    <span>{title}</span>
                </div>
                {
                    design ? (
                        <div>
                            <draggable class="drawing-board" animation={340} list={propRows} group="componentsGroup">
                                {
                                    propRows.map((item, index) => {
                                        return (
                                            <draggable-item
                                                key={index}
                                                current-item={item}
                                                drawing-list={propRows}
                                                index={index}
                                                in-table={true}
                                                selectItem={this.$attrs.selectItem}
                                                onActiveItem={activeItem}
                                                onDeleteItem={delItem}
                                            />
                                        )
                                    })
                                }
                            </draggable>
                            <div style="color: #c0bebe; text-align: center; width: 90%; padding: 5px">
                                    ☝ 拖拽控件到表格内部
                            </div>
                        </div>
                    ) : 
                    rows.map((item, index) => {
                        const { __vModel__, __config__: { span, showLabel, label } } = item
                        return (
                            <el-col span={span} style="padding: 10px 0">
                                <el-form-item label-width="120px" prop={__vModel__} label={showLabel ? label : ""}>
                                    <render info={info} formSlot={{scopedSlots}} conf={item} onInput={value => setValue(value, __vModel__)} attrs={this.$attrs} />
                                </el-form-item>
                            </el-col>
                        )
                    })
                }
            </el-card>
        )
    }
}
</script>
<style>
.drawing-board {
    min-height:120px;
    display: block;
}
</style>